var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRating5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_69311",
    "data-name": "Group 69311",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 150.94,
    height: 143.954,
    viewBox: "0 0 150.94 143.954",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_141832",
    "data-name": "Rectangle 141832",
    width: 150.94,
    height: 143.954,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_86043",
    "data-name": "Path 86043",
    d: "M65.139,58.035c-1.392,1.035-41.585,1.832-44.993,11.817s28.217,34.577,28.763,36.675-9.54,40.538-1.992,45.719c4.192,2.879,16.435-2.224,26.857-7.328,8.338-4.084,15.51-8.167,16.46-8.162,2.139.012,37.187,20.567,43.319,15.489s-2.027-44.568-1.288-46.423,31.274-28.43,28.058-35.971-42.688-10.821-44.287-11.817-15.33-39.106-25.8-39.106S66.531,57,65.139,58.035",
    transform: "translate(-19.889 -18.929)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.126,
    y1: 0.849,
    x2: 0.127,
    y2: 0.849,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff466"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.043,
    stopColor: "#fff466"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.075,
    stopColor: "#fff466"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.314,
    stopColor: "#ffeb5f"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.687,
    stopColor: "#ffd54d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.86,
    stopColor: "#ffc943"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffc943"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_141830",
    "data-name": "Rectangle 141830",
    width: 80.006,
    height: 16.728,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_141828",
    "data-name": "Rectangle 141828",
    width: 18.12,
    height: 16.728,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_69310",
    "data-name": "Group 69310",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69296",
    "data-name": "Group 69296"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69295",
    "data-name": "Group 69295",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_86042",
    "data-name": "Path 86042",
    d: "M75.484,0C86.717,0,102.2,39.375,103.92,40.444s43.309,6.1,46.76,14.19-28.555,37.357-29.348,39.348,7.2,43.6.625,49.052-44.18-15.851-46.473-15.864-38.376,21.423-46.475,15.864,1.209-46.8.624-49.052S-3.37,65.345.287,54.633s45.265-13.08,46.758-14.19S64.249,0,75.484,0",
    transform: "translate(0)",
    fill: "#ffbd39"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_69298",
    "data-name": "Group 69298",
    transform: "translate(5.137 4.889)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69297",
    "data-name": "Group 69297",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_141827",
    "data-name": "Rectangle 141827",
    width: 201.368,
    height: 200.286,
    transform: "matrix(0.769, -0.64, 0.64, 0.769, -71.202, 56.65)",
    fill: "url(#linear-gradient)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_69309",
    "data-name": "Group 69309"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69308",
    "data-name": "Group 69308",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_86044",
    "data-name": "Path 86044",
    d: "M56.32,201.537c-.729-7.1,22.564-11.279,23.591-2.972s-22.6,12.645-23.591,2.972",
    transform: "translate(-41.762 -143.878)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86045",
    "data-name": "Path 86045",
    d: "M170.8,192.122c-.175-4.567,6.787-4.845,7.15-1.1.4,4.195-6.989,5.37-7.15,1.1",
    transform: "translate(-126.685 -139.767)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_69307",
    "data-name": "Group 69307",
    transform: "translate(35.467 69.393)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69306",
    "data-name": "Group 69306"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69305",
    "data-name": "Group 69305",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69301",
    "data-name": "Group 69301",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69300",
    "data-name": "Group 69300"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69299",
    "data-name": "Group 69299",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_86046",
    "data-name": "Path 86046",
    d: "M155.446,277.051c0,4.619-4.057,8.365-9.06,8.365s-9.06-3.746-9.06-8.365,4.057-8.363,9.06-8.363,9.06,3.744,9.06,8.363",
    transform: "translate(-137.326 -268.688)",
    fill: "#ff5f82"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_69304",
    "data-name": "Group 69304",
    transform: "translate(61.886)",
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69303",
    "data-name": "Group 69303"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_69302",
    "data-name": "Group 69302",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_86047",
    "data-name": "Path 86047",
    d: "M395.065,277.051c0,4.619-4.057,8.365-9.06,8.365s-9.06-3.746-9.06-8.365,4.057-8.363,9.06-8.363,9.06,3.744,9.06,8.363",
    transform: "translate(-376.945 -268.688)",
    fill: "#ff5f82"
  }))))))), /*#__PURE__*/React.createElement("path", {
    id: "Path_86048",
    "data-name": "Path 86048",
    d: "M189.266,296.432c1.2-.905,50.686-.955,51.967,0,2.493,1.861,1.047,23.058-25.446,23.058s-28.983-21.2-26.521-23.058",
    transform: "translate(-139.838 -219.356)",
    fill: "#872a2a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86049",
    "data-name": "Path 86049",
    d: "M151.113,212.213c-2.317-1.959,1.13-12.5,10.351-12.5s12.493,10.411,10.578,12.5c-1.657,1.806-3.689-6.511-10.352-6.511s-8.619,8.167-10.578,6.511",
    transform: "translate(-111.568 -148.133)",
    fill: "#541300"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_86050",
    "data-name": "Path 86050",
    d: "M348.931,212.213c-2.319-1.959,1.129-12.5,10.352-12.5s12.493,10.411,10.576,12.5c-1.657,1.806-3.689-6.511-10.353-6.511s-8.619,8.167-10.576,6.511",
    transform: "translate(-258.295 -148.133)",
    fill: "#541300"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRating5);
export default __webpack_public_path__ + "static/media/rating-5.112424e535bf2ae33226248b538a512f.svg";
export { ForwardRef as ReactComponent };